export const inviteeRole = {
	ROLE_COACH: 'COACH',
	ROLE_COLLEAGUE: 'COLLEAGUE',
	ROLE_EXTERNAL_ADVISOR: 'EXTERNAL_ADVISOR',
	ROLE_COMPANY_OWNER: 'COMPANY_OWNER'
} as const;

export type IInviteeRole = typeof inviteeRole[keyof typeof inviteeRole];
